<script setup>
import SectionLayout from 'dashboard/components-next/SectionLayout.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const pageTitle = computed(() => {
  const titleMap = {
    conversation_reports: 'REPORT.HEADER',
    agent_reports: 'AGENT_REPORTS.HEADER',
    label_reports: 'LABEL_REPORTS.HEADER',
    inbox_reports: 'INBOX_REPORTS.HEADER',
    team_reports: 'TEAM_REPORTS.HEADER',
    account_overview_reports: 'OVERVIEW_REPORTS.ACCOUNT_CONVERSATIONS.HEADER',
    sla_reports: 'SLA_REPORTS.HEADER',
    csat_reports: 'CSAT_REPORTS.HEADER',
    bot_reports: 'BOT_REPORTS.HEADER',
    bulk_summary_reports: 'BULK_SUMMARY_REPORTS.HEADER',
    data_collection_reports: 'DATA_COLLECTION_REPORTS.TITLE',
  };
  return titleMap[route.name] || 'REPORT.HEADER';
});
</script>

<template>
  <SectionLayout :title="$t(pageTitle)">
    <div class="reports--wrapper">
      <router-view />
    </div>
  </SectionLayout>
</template>

<style scoped lang="scss">
.reports--wrapper {
  ::v-deep {
    .multiselect--disabled { @apply opacity-50 border border-n-gray-2 dark:border-n-gray-8 rounded-md cursor-not-allowed; }
    .multiselect__content-wrapper { @apply bg-n-solid-2 border border border-n-gray-2 dark:border-n-gray-8 text-n-slate-12; }
    .multiselect__tags { @apply bg-n-slate-1 border border-n-gray-2 dark:border-n-gray-8 m-0 min-h-[2.875rem] pt-0; }
    .multiselect__tags input[type='text'] { @apply bg-n-alpha-3 border border-n-gray-2 dark:border-n-gray-8 !min-h-[2.375rem] !h-[2.375rem] !ps-0.5 !py-0 !text-sm; }
    .multiselect__placeholder { @apply text-n-slate-11; }
    .multiselect__select { @apply min-h-0; }
    .multiselect__single { @apply bg-n-alpha-3 text-n-slate-11; }
    .multiselect__input { @apply text-sm !h-[2.375rem] mb-0 !py-0; }
    .multiselect__tags { @apply bg-n-alpha-3 border border-n-gray-2 dark:border-n-gray-8 text-n-slate-12 rounded-lg text-sm min-h-[2.5rem]; }
    .multiselect__input,
    .multiselect { @apply bg-n-alpha-3 border-0 text-n-slate-12 rounded-lg text-sm min-h-[2.5rem]; }
    .mx-input-wrapper { @apply bg-n-alpha-3 border border-n-gray-2 dark:border-n-gray-8 text-n-slate-12 rounded-lg text-sm; }
    .mx-input-wrapper input { @apply border border-n-gray-2 dark:border-n-gray-8 text-sm; }
    .multiselect__option { @apply flex items-center; }
    .mx-datepicker .mx-input { @apply bg-n-alpha-3; }
    .mx-datepicker .mx-input-wrapper input::placeholder { @apply text-n-slate-11; }
    .mx-datepicker .mx-input-wrapper input { @apply text-n-slate-11; }
    .multiselect--active:not(.multiselect--above) .multiselect__current,
    .multiselect--active:not(.multiselect--above) .multiselect__input,
    .multiselect--active:not(.multiselect--above) .multiselect__tags { @apply rounded-b-none; }
  }
}
</style>
